@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package orecompose.oreui_panorama.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val panorama_default: DrawableResource by 
      lazy { init_panorama_default() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("panorama_default", CommonMainDrawable0.panorama_default)
}

internal val Res.drawable.panorama_default: DrawableResource
  get() = CommonMainDrawable0.panorama_default

private fun init_panorama_default(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:panorama_default",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/orecompose.oreui_panorama.generated.resources/drawable/panorama_default.png", -1, -1),
    )
)
